<div class="suggested-container">
    <div class="label">Suggested</div>
    <div class="title">{{ relation }}</div>
    <div class="btn-container">
        <input type="button" value="Add" (click)="addADelegate(relation)">
        <div class="close-btn" (click)="onRemoveSuggestionClick()">X</div>
    </div>
</div>